<template>
    <div>
        <div id="wrapper" class="wrapper haslayout">
            <WebPortalHeader />
            <!--************************************
                    Main Start
                    *************************************-->
                    <main id="bg-main" class="bg-main Notice_mainsec">
                <!--************************************
                    DGME links Start
                    *************************************-->
                    <section class=" haslayout st-shape-wrap">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="webportal-contant">
                                    <LeftSlider />
                                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 ">
                                        <div class="row">
                                            <div class="mid_contant">
                                                <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12 mt-5">
                                                    <div class="row" id="blog-board">
                                                        <div>
                                                            <h2 class="item-title title-bar-primary4">
                                                            Frequently Ask Any Question</h2>
<!--                                                             <template>
                                                                <div id="accordion">
                                                                <div class="card">
                                                              <v-expansion-panels>
                                                                <v-expansion-panel
                                                                v-for="item in getFaqData" class="card-header" 
                                                                >
                                                                <v-expansion-panel-header color="  white--text">
                                                                    {{item.question}}
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content class="st-accordian-body card-body">
                                                                    {{item.answer}}
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </div>
                                                </div>
                                                    </template> -->
                                                    <div id="accordion">
                                                        <div class="card" v-for="(item, index) in getFaqData" :key="index">
                                                            <div class="card-header">
                                                                <a class="card-link" >
                                                                   {{item.question}}<span class="st-accordian-toggle fa fa-angle-down"></span>
                                                                </a>
                                                            </div>
                                                            <div  class="collapse show" >
                                                                <div class="st-accordian-body card-body" v-html="item.answer">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="card">
                                                            <div class="card-header">
                                                                <a class="collapsed card-link" >
                                                                    Question 2
                                                                    <span class="st-accordian-toggle fa fa-angle-down"></span>
                                                                </a>
                                                            </div>
                                                            <div  class="collapse in" >
                                                                <div class="st-accordian-body card-body">
                                                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                      <!--   <div class="card">
                                                            <div class="card-header">
                                                                <a class="collapsed card-link" >
                                                                    Question 3
                                                                    <span class="st-accordian-toggle fa fa-angle-down"></span>
                                                                </a>
                                                            </div>
                                                            <div  class="collapse in" >
                                                                <div class="st-accordian-body card-body">
                                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                       <!--  <div class="card">
                                                            <div class="card-header">
                                                                <a class="collapsed card-link" >
                                                                    Question 4
                                                                    <span class="st-accordian-toggle fa fa-angle-down"></span>
                                                                </a>
                                                            </div>
                                                            <div  class="collapse in" >
                                                                <div class="st-accordian-body card-body">
                                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                        <!-- <div class="card">
                                                            <div class="card-header">
                                                                <a class="collapsed card-link" >
                                                                    Question 5
                                                                    <span class="st-accordian-toggle fa fa-angle-down"></span>
                                                                </a>
                                                            </div>
                                                            <div  class="collapse in" >
                                                                <div class="st-accordian-body card-body">
                                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <RightSlider />
                        </div>
                    </div>
                </div>
                <div class="st-shape2"><img src="../../assets/images/contact-shape1.svg" alt="shape2"></div>

            </section>
                <!--************************************
                    DGME links Start
                    *************************************-->
                </main>
            <!--************************************
                    Main End
                    *************************************-->
                    <WebPortalFooter />
                </div>
            </div>
        </template>

    <script>
        import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
        import LeftSlider from "../../components/webPortalLayout/LeftSlider";
        import RightSlider from "../../components/webPortalLayout/RightSlider";
        import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";
        export default {
            name: "Faq",
            components: {
                WebPortalHeader,
                LeftSlider,
                RightSlider,
                WebPortalFooter,
            },
            created() {
                this.$store.dispatch("callFaqPublicData");
                this.$store.dispatch("callHeaderFooterPublicData");
            },
            computed: {
                getFaqData() {
                    return this.$store.getters.getFaqData;
                },

            },
        }
    </script>

<style scoped>
    .row {
        display: block;
        flex-wrap: wrap;
        flex: 1 1 auto;
    }
</style>
